// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Roma Components
import { Button } from '@milanote/roma';

// Styles
import './ModalActionsList.scss';

const ModalActionsList = ({ actions }) => (
    <ul className="ModalActionsList">
        {actions.map((action, index) => (
            <li key={index}>
                {action.to ? (
                    <Button
                        href={action.to}
                        routerOptions={{ keepParams: action.keepParams }}
                        color="link-color"
                        size="md"
                    >
                        {action.text}
                    </Button>
                ) : (
                    <a href={action.href || '#'} onClick={action.func}>
                        {action.text}
                    </a>
                )}
            </li>
        ))}
    </ul>
);

ModalActionsList.propTypes = {
    actions: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            func: PropTypes.func,
            to: PropTypes.string,
            keepParams: PropTypes.bool,
            href: PropTypes.string,
        }),
    ),
};

export default ModalActionsList;
